import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import CrudMain from "../../../components/crud/CrudMain";
import FormikForm from "../../../components/crud/FormikForm";
import { Field } from "formik";
import TextInput from "../../../components/form-fields/TextInput";
import MultiSelect from "../../../components/form-fields/MultiSelect";
import * as yup from "yup";
import { Nav, Tab, Button } from "react-bootstrap";
import FileUpload from "../../../components/fields/FileUpload";
import EmailInput from "../../../components/form-fields/EmailInput";
import CurrencyInput from "../../../components/form-fields/CurrencyInput";
import Select from "../../../components/form-fields/Select";
import TextArea from "../../../components/form-fields/TextArea";
import Checkbox from "../../../components/form-fields/Checkbox";
import LastStatus from "./partial-views/LastStatus";
import Documents from "./partial-views/Documents";
import TimesSpent from "./partial-views/TimesSpent";
import DocumentHistory from "./partial-views/DocumentHistory";
import { DEMAND_TYPES, MASRAF_TAB_CASES, CASE_TYPES1, CASE_TYPES2, DEMAND_TYPE_CASES_1, DEMAND_TYPE_CASES_2 } from "../../../shared/enums";
import ReactDatePicker from "../../../components/form-fields/ReactDatePicker";
import request from "../../../services/request";
import { useTranslation } from "react-i18next"; /* Added Line */
import { formatCurrencyWithDouble } from "../../../utils";
import moment from "moment";
import { ThemeContext } from '../../../../context/ThemeContext';
import Expenses from "./partial-views/Expenses";

DemandUpdate.propTypes = {};

function DemandUpdate(props) {
  const [configData, setConfigData] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [docTypeElements, setDocTypeElements] = useState([]);
  const [davaDosyaDurum, setDavaDosyaDurum] = useState([]);
  const [index, setIndex] = useState(1);
  const [disableButtons, setDisableButtons] = useState(false);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [bedel, setBedel] = useState();
  const { isDisAvukat, IsMasrafCheck, userObj } = useContext(ThemeContext);
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [companies, setCompanies] = useState([]);
  const [combineCompanies, setCombineCompanies] = useState([]);
  const [isGucuTextboxVisibility, setIsGucuTextboxVisibility] = useState(false);
  const [disableIsGucu, setDisableIsGucu] = useState(false);
  const [ilgiliSirketAreaVisibility, setIlgiliSirketAreaVisibility] = useState(false);
  const [ilgiliSirketTextboxVisibility, setIlgiliSirketTextboxVisibility] = useState(false);
  const [slctdDavaTuru, setSlctdDavaTuru] = useState(-1);
  const [davaTuru2Options, setDavaTuru2Options] = useState([]);
  const [sorumluEpostaTextboxVisibility, setSorumluEpostaTextboxVisibility] = useState(false);
  const [sorumluAdiTextboxVisibility, setSorumluAdiTextboxVisibility] = useState(false);

  const validationSchema = yup.object({});

  const davaTuru2Types = [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IS_DAVALARI,
    CASE_TYPES1.YENI_SAVCILIK_SIKAYETI_YAPILMASI,
    CASE_TYPES1.ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI
  ];

  var ids = [];
  var tarafText = "";

  useEffect(() => {
    getCompanies();
    getCombinedCompanies();
    checkIsGucu();
    checkIlgiliSirket();
  }, [props.showModal]);

  const checkIsGucu = () => {
    if (props.selectedRow?.isGucuBirimId === 132) {
      setIsGucuTextboxVisibility(true);
    } else {
      setIsGucuTextboxVisibility(false);
    }
  };

  const checkIlgiliSirket = () => {
    props.selectedRow?.ilgiliSirket ? setIlgiliSirketAreaVisibility(true) : setIlgiliSirketAreaVisibility(false)
    props.selectedRow?.ilgiliSirketText ? setIlgiliSirketTextboxVisibility(true) : setIlgiliSirketTextboxVisibility(false)
  };

  const onIsGucuBirimChange = (id) => {
    if(id === 132) {
      setIsGucuTextboxVisibility(true);
    } else {
      setIsGucuTextboxVisibility(false);
    }
  };

  const arrangeBeforePersist = (values) => {
    let payload = {
      id: values.id,
      fileIds: values.fileIds ? values.fileIds.map((f) => f.id) : [],
      sorumluAdi: values.sorumluAdi,
      sorumluEposta: values.sorumluEposta,
      sorumluTel: values.sorumluTel,
      dosyaTuruId: values.dosyaTuruId,
      dosyaTuruIds: values.dosyaTuruList,
      konu: values.konu,
      aciklama: values.aciklama,
      durumId: values.durumId,
      davaTuru: values.davaTuru,
      sirketId: values.sirketId,
      isGucuBirimId: values.isGucuBirimId,
      isGucuBirimIdDiger: values.isGucuBirimIdDiger,
      taraf1: values.taraf1,
      sorumluRolu: values.sorumluRolu,
      mudahil: values.mudahil,
      davali: values.davali,
      yonlendiriciYorum: values.yonlendiriciYorum,
      avukatYorumu: values.avukatYorumu,
      avukatId: values.avukatId,
      bedel:
        values.bedel && parseFloat(values.bedel.toString().replaceAll(",", "")),
      szlThmBedelTuru: values.szlThmBedelTuru,
      paraBirimi: values.paraBirimi,
      daireNo: values.daireNo,
      icraNo: values.icrano,
      dil: values.dil,
      surecTarih: values.surecTarih,
      dosyaDurumId: values.dosyaDurumId,
      gorevlendirilmisDisAvukatlar: (Array.isArray(values.gorevlendirilmisDisAvukatlar) ? values.gorevlendirilmisDisAvukatlar?.map(s => { return { "userId": s } }) : [{ "userId": values.gorevlendirilmisDisAvukatlar }]),
      // disAvukatGorebilir: values.disAvukatGorebilir,
      vekilSirket: values.vekilSirket,
      ihtarEden: values.ihtarEden,
      basvurulanSirket: values.basvurulanSirket,
      davaTarihi: values.durusmaTarihi,
      talepBilgideTutList: values.bilgideTutulanlar?.map((bt) => {
        return {
          talepId: props.selectedRow.id,
          userId: bt,
        };
      }),
      davaliCompanyList: values.davaliCompanyList?.map(s => { return { "companyId": s } }),
      tarafCompanyList: values.tarafCompanyList?.map(s => { return { "companyId": s } }),
      onemli: values.updateOnemli,
      ilgiliSirketId: values.ilgiliSirketId,
      ilgiliSirketText: values.ilgiliSirketText,
      ikinciDavaTuru: values.ikinciDavaTuru,
      ilkDavaTuru: values.ilkDavaTuru
    };
    return payload;
  };

  const getDocTypeParentId = (dosyaTur) => {
    if (dosyaTur.parent) {
      ids.push(dosyaTur.parent.id);
      if (dosyaTur.parent.parent) {
        getDocTypeParentId(dosyaTur.parent);
      }
    }
  };

  const adaptDataForUpdate = (data) => {
    ids.push(
      92 > data.dosyaTuruId
        ? data.dosyaTuruId
        : 137 < data.dosyaTuruId
          ? data.dosyaTuruId
          : 0
    );
    //getDocTypeParentId(data.dosyaTur);
    setDisableButtons(!data.departmanYoneticisiMi);
    let adaptedData = {
      id: data.id,
      sorumluAdi: data.sorumluAdi,
      sorumluEposta: data.sorumluEposta,
      sorumluTel: data.sorumluTel,
      dosyaTuruId: data.dosyaTuruId,
      dosyaTuruList: data.dosyaTuruList?.map((c) => c.dosyaTurId),
      konu: data.konu,
      aciklama: data.aciklama,
      durumId: data.durumId,
      davaTuru: data.davaTuru,
      sirketId: data.sirketId,
      isGucuBirimId: data.isGucuBirimId,
      isGucuBirimIdDiger: data.isGucuBirimIdDiger,
      taraf1: data.taraf1,
      sorumluRolu: data.sorumluRolu,
      mudahil: data.mudahil,
      davali: data.davali,
      yonlendiriciYorum: data.yonlendiriciYorum,
      avukatYorumu: data.avukatYorumu,
      avukatId: data.avukatId,
      bedel: data.bedel && formatCurrencyWithDouble(data.bedel),
      szlThmBedelTuru: data.szlThmBedelTuru,
      paraBirimi: data.paraBirimi,
      daireNo: data.daireNo,
      icraNo: data.icraNo,
      fileIds: data.fileIds,
      cdate: data.cdate && new Date(data.cdate),
      talepEdenSirket: data.company.name,
      talepEdenKisi: data.createdUser.fullName,
      iadeNedeni: data.iadeNedeni,
      iadeEdenUser: data.iadeEdenUser?.fullName,
      iadeTarihi: data.iadeTarihi && moment(data.iadeTarihi).format("DD.MM.YYYY HH:MM:SS"),
      dil: data.dil,
      surecTarih: data.surecTarih && new Date(data.surecTarih),
      dosyaDurumId: data.dosyaDurumId,
      gorevlendirilmisDisAvukatlar: (Array.isArray(data.gorevlendirilmisDisAvukatlar) ? data.gorevlendirilmisDisAvukatlar?.map((c) => c.userId) : data.gorevlendirilmisDisAvukatlar),
      // disAvukatGorebilir: data.disAvukatGorebilir,
      vekilSirket: data.vekilSirket,
      ihtarEden: data.ihtarEden,
      basvurulanSirket: data.basvurulanSirket,
      durusmaTarihi: data.davaTarihi && new Date(data.davaTarihi),
      bilgideTutulanlar: data.talepBilgideTutList?.map((bt) => bt.userId),
      davaliCompanyList: data.davaliCompanyList?.map((c) => c.companyId),
      tarafCompanyList: data.tarafCompanyList?.map((c) => c.companyId),
      onemli: data.updateOnemli,
      ilgiliSirketId: data.ilgiliSirketId,
      ilgiliSirketText: data.ilgiliSirketText,
      ikinciDavaTuru: data.ikinciDavaTuru,
      ilkDavaTuru: data.ilkDavaTuru      
    };
    setInitialValues(adaptedData);
    setSlctdDavaTuru(data.ilkDavaTuru);

    if (configData?.tumKullanicilar.filter(a => a.label == adaptedData.sorumluAdi).length == 0) {
      setSorumluAdiTextboxVisibility(true);
    }
    if (configData?.tumKullanicilar.filter(a => a.otherValue == adaptedData.sorumluEposta).length == 0) {
      setSorumluEpostaTextboxVisibility(true);
    }
  };

  const typeCheckWithPage = (
    type,
    filterValues = [],
    pageType,
    filterPageType = []
  ) => {
    let index = filterValues.findIndex((fv) => fv == type);
    let pageIndex = filterPageType.findIndex((fpv) => fpv == pageType);

    if (index != -1 && pageIndex != -1) {
      return true;
    }

    return false;
  };

  const typeCheck = (type, filterValues = []) => {
    let index = filterValues.findIndex((fv) => fv == type);

    if (index != -1) {
      return true;
    }

    return false;
  };

  const getEndpointUrl = (props) => {
    //TODO: tüm istekler net olduktan sonra bu kısım revize edilmeli

    // bekleyen-talepler
    if (props.type === 1) return props.endpoint;

    // G20-546
    if (
      (props.type === 2 || props.type === 3) &&
      typeCheck(
        props.selectedRow && props.selectedRow.talepTur.id,
        [47, 48, 42, 44, 43, 45, 50, 51, 49, 79, 52, 63]
      )
    )
      return null;

    // G20-545
    if (
      !typeCheck(props.selectedRow && props.selectedRow.talepTur.id, [
        DEMAND_TYPES.SOZLESMELERLE_ILGILI_SORU,
        DEMAND_TYPES.PLADIS_SOZLESMEUYUSMAZLIKLAR,
        DEMAND_TYPES.TIO_SOZLESMELERLE_ILGILI_SORU
      ]) &&
      (props.type !== 2 || props.type !== 3) && // devam ediyor yada yölendirilmiş
      !typeCheck(props.selectedRow && props.selectedRow.talepTur.id, [
        DEMAND_TYPES.MARKA_PATENT,
        DEMAND_TYPES.REKLAM_DIGER,
        DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
        DEMAND_TYPES.BILISIM_VE_INTERNET,
        DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
        DEMAND_TYPES.MP_MUTALAADANISMA,
        DEMAND_TYPES.FMH_TOPLANTI,
      ])
    )
      return props.endpoint;

    return null;
  };

  const onBedelChanged = (val) => {
    props.selectedRow.szlThmBedelTuru = val;
    setBedel(val);
  };

  const onDosyaDurumuChange = (opt) => {
    // if (
    //   props.selectedRow &&
    //   (props.selectedRow.talepTur.id == DEMAND_TYPES.ICRA_TAKIBI ||
    //     props.selectedRow.talepTur.id == DEMAND_TYPES.DAVA_YENI_TALEP)
    // ) {
    //   request({
    //     url: "",
    //     method: "POST",
    //     data: {
    //       body: {
    //         id: opt,
    //       },
    //     },
    //   }).then((response) => {
    //     if (response.responseStatus === "SUCCESS") {
    //     }
    //   });
    // }
  };

  const davaliAndDavaciFieldsChecker = () => {
    return (
      typeCheckWithPage(
        props.selectedRow.talepTur.id,
        [
          DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
          DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
          DEMAND_TYPES.SOZLESME,
          DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
          DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
          DEMAND_TYPES.TIO_SOZLESME,
          DEMAND_TYPES.ICRA_TAKIBI,
          DEMAND_TYPES.PLADIS_ICRA,
          DEMAND_TYPES.TIO_ICRA_TAKIBI,
          DEMAND_TYPES.DAVA_YENI_TALEP,
          DEMAND_TYPES.TH_KAMULASTIRMA,
          DEMAND_TYPES.PLADIS_YENIDAVA,
          DEMAND_TYPES.GH_IS_HUKUKU,
          DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
          DEMAND_TYPES.VEKALETNAME,
          DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
          DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
          DEMAND_TYPES.SAVCILIK,
          DEMAND_TYPES.PLADIS_SAVCILIK,
          DEMAND_TYPES.TIO_SAVCILIK,
          DEMAND_TYPES.FMH_YENI_DAVA,
          DEMAND_TYPES.FMH_ALEYHE_DAVA,
          DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
          DEMAND_TYPES.PLADIS_ALEYHEACILAN,
          DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
          DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
          DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
          DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
          DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
          DEMAND_TYPES.TIO_IHTARNAME,
          DEMAND_TYPES.GENEL_H_IHTARNAME,
          DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
          DEMAND_TYPES.HACIZ_IHBARNAMELERI,
          DEMAND_TYPES.PLADIS_HACIZ,
          DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
          DEMAND_TYPES.RESMI_KURUM_TALEP,
          DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
          DEMAND_TYPES.MP_RAPORLAMALAR, 
          DEMAND_TYPES.PLADIS_RAPORLAMALAR,
          DEMAND_TYPES.TIO_RAPORLAMALAR,
          DEMAND_TYPES.FMH_RAPORLAMALAR,
        ],
        props.pageType,
        [1, 2]
      )
    )
  }

  const getCompanies = () => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          /* companyGroupIds: companyGroupIds, */
          /* yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany, */
          talepTurId: props.selectedRow?.talepTur.id
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const getDavaTuru1Options = () => {

    let data = configData?.ilkDavaTurleri || (() => {
      return Object.keys(CASE_TYPES2).map((i) => {
        return { label: i, value: CASE_TYPES2[i] };
      });
    })();

    if (!(props.selectedRow && props.selectedRow.talepTur.id)) {
      return [];
    }
    const types = DEMAND_TYPE_CASES_1[props.selectedRow.talepTur.id] || [];
    return data.filter(a => types.indexOf(a.value) > -1);
  }
  
  const getDavaTuru2 = () => {
    let data = configData?.ikinciDavaTurleri || (() => {
      return Object.keys(CASE_TYPES2).map((i) => {
        return { label: i, value: CASE_TYPES2[i] };
      });
    })();

    const types = DEMAND_TYPE_CASES_2[slctdDavaTuru] || [];
    return data.filter(a => types.indexOf(a.value) > -1);
  };

  const getCombinedCompanies = () => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          /* companyGroupIds: companyGroupIds, */
          /* yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany, */
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCombineCompanies(response.body.tableData);
      }
    });
  };

  if (props.selectedRow) {
    switch (props.selectedRow.talepTur.id) {
      case DEMAND_TYPES.VEKALETNAME:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.SOZLESME:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.GH_IS_HUKUKU:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.TIO_SOZLESME:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.ORTAKLIKJV_KURULUSU:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.HACIZ_IHBARNAMELERI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.PLADIS_HACIZ:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.TIO_IHTARNAME:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.TIO_IHTARNAME:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.GENEL_H_IHTARNAME:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.PLADIS_SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.TIO_SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.MP_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.PLADIS_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.TIO_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.FMH_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.RESMI_KURUM_TALEP:
        tarafText = "demandCreate.resmiDaire";
        break;
      case DEMAND_TYPES.ICRA_TAKIBI:
        tarafText = "demandCreate.alacakli";
        break;
      case DEMAND_TYPES.PLADIS_ICRA:
        tarafText = "demandCreate.alacakli";
        break;
      case DEMAND_TYPES.TIO_ICRA_TAKIBI:
        tarafText = "demandCreate.alacakli";
        break;

      default:
        tarafText = "demandCreate.davaci";
        break;
    }
  }

  return (
    <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <CrudMain
          showModal={props.showModal}
          setShowModal={props.setShowModal}
          setInitialValues={setInitialValues}
          hideNewAddButton
          title={props.title}
          size={"lg"}
        >
          <Tab.Container defaultActiveKey={"bilgiler"}>
            <Nav as="ul" className="nav-tabs">
              <Nav.Item as="li" key={1}>
                <Nav.Link eventKey={"bilgiler"}>{t("tabs.bilgiler")}</Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" key={2}>
                <Nav.Link eventKey={"sondurum"}>{t("tabs.sonDurum")}</Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" key={3}>
                <Nav.Link eventKey={"dokumanlar"}>
                  {t("tabs.dokumanlar")}
                </Nav.Link>
              </Nav.Item>
              {!isDisAvukat ? (
                <>
                  <Nav.Item as="li" key={4}>
                    <Nav.Link eventKey={"harcanansureler"}>
                      {t("tabs.harcananSureler")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" key={5}>
                    <Nav.Link eventKey={"dosyagecmisi"}>
                      {t("tabs.talepAkisi")}
                    </Nav.Link>
                  </Nav.Item>
                </>
              ) : null}
              { props.selectedRow && IsMasrafCheck && (typeCheck(props.selectedRow.talepTur.id, MASRAF_TAB_CASES )) && (
                <Nav.Item as="li" key={6}>
                  <Nav.Link eventKey={"masraflar"}>
                    {t("tabs.masraflar")}
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
            <Tab.Content className="pt-4">
              <Tab.Pane eventKey={"bilgiler"} key={1}>
                <FormikForm
                  keyField={"bilgilerForm"}
                  isUpdating={props.isUpdating}
                  entityId={props.selectedRow && props.selectedRow.id}
                  entityFetchId="id"
                  //numara vermeden bitirilmesi gereken taleplerde ana submit buttonu iptal olacak
                  endPointUrl={getEndpointUrl(props)}
                  configParameterName="talepTurId"
                  configParameterValue={
                    props.selectedRow && props.selectedRow.talepTur.id
                  }
                  configReqType={"POST"}
                  fetchPointUrl="yonlendirilecek-talep/find"
                  editPointUrl={props.endpoint}
                  configPointUrl="yonlendirilecek-talep/config"
                  arrangeBeforePersist={arrangeBeforePersist}
                  adaptDataForUpdate={adaptDataForUpdate}
                  setConfigData={(data) => {
                    setConfigData(data);
                  }}
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  closeModal={() => {
                    props.setShowModal(false);
                    setSorumluAdiTextboxVisibility(false);
                    setSorumluEpostaTextboxVisibility(false);
                    setInitialValues({});
                  }}
                  refreshList={() => props.setRefreshList(!props.refreshList)}
                  extraButton={props.extraButton}
                  extraButtonOnClick={props.extraButtonOnClick}
                  extraButtonText={props.extraButtonText}
                  okButtonText={props.okButtonText}
                  endPointUrl2={props.endPointUrl2}
                  //numara vermeden bitirilmesi gereken taleplerde buton adı değişecek
                  secondSubmitButttonText={
                    !typeCheck(
                      props.selectedRow && props.selectedRow.talepTur.id,
                      [DEMAND_TYPES.SOZLESMELERLE_ILGILI_SORU, DEMAND_TYPES.PLADIS_SOZLESMEUYUSMAZLIKLAR, DEMAND_TYPES.TIO_SOZLESMELERLE_ILGILI_SORU, DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA]
                    ) && getEndpointUrl(props)
                      ? props.secondSubmitButttonText
                      : t("actionButtonGenerator.bitir")
                  }
                  endPointUrl3={props.endPointUrl3}
                  thirdSubmitButttonText={props.thirdSubmitButttonText}
                  endPointUrl4={props.endPointUrl4}
                  fourthSubmitButttonText={props.fourthSubmitButttonText}
                  disableButtons={disableButtons}
                >
                  {!isDisAvukat && <Field
                    name="id"
                    label={t("demandUpdate.islemNo")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="talepEdenSirket"
                    label={t("demandUpdate.talepEdenSirket")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="talepEdenKisi"
                    label={t("demandUpdate.talepEdenKisi")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="cdate"
                    label={t("demandUpdate.talepTarihi")}
                    colNumber="6"
                    component={ReactDatePicker}
                    readOnly
                  />}
                  { ilgiliSirketAreaVisibility &&
                    <div className="form-group col-md-6">
                      <Field
                        name="ilgiliSirketId"
                        label={t("demandCreate.ilgiliSirket")}
                        colNumber="-6"
                        buttonLabel = {
                          <>
                            <Button
                              className="btn-xs ml-3 px-2 py-1 rounded-circle"
                              variant="primary"
                              onClick={() => setIlgiliSirketTextboxVisibility(!ilgiliSirketTextboxVisibility)}
                            >
                                <i className={ "fa fa-" + (ilgiliSirketTextboxVisibility ? "minus" : "plus") }/>
                            </Button>
                          </>
                        }
                        component={Select}
                        options={companies.map(item => { return { value: item.id, label: item.name } })}
                        required            
                      />
                      { ilgiliSirketTextboxVisibility &&
                        <Field
                          name="ilgiliSirketText"
                          label={t("demandCreate.other")}
                          colNumber="-6 hide-label"
                          component={TextInput}
                        />
                      }
                    </div>
                  }
                  {!isDisAvukat && <Field
                    name="fileIds"
                    label={t("demandUpdate.dosya")}
                    colNumber="12"
                    component={FileUpload}
                  />}
                  {!isDisAvukat && 
                  <div className="form-group col-md-6">
                    <Field
                      name="sorumluAdi"
                      label={t("demandCreate.sorumluAdi")}
                      colNumber="-6"
                      component={Select}
                      options={configData && configData.tumKullanicilar.filter(a => a.label && a.label != '').map(a => { return { value: a.label, label: (a.label || '--') } })}
                      buttonLabel = {
                        <>
                          <Button
                            className="btn-xs ml-3 px-2 py-1 rounded-circle"
                            variant="primary"
                            onClick={() => setSorumluAdiTextboxVisibility(!sorumluAdiTextboxVisibility)}
                          >
                              <i className={ "fa fa-" + (sorumluAdiTextboxVisibility ? "minus" : "plus") }/>
                          </Button>
                        </>
                      }
                      readOnly={isDisAvukat}
                      required
                    />
                    { sorumluAdiTextboxVisibility &&
                      <Field
                        name="sorumluAdi"
                        label={t("demandCreate.other")}
                        colNumber="-6 hide-label"
                        component={TextInput}
                        readOnly={isDisAvukat}
                        required
                      />
                    }
                  </div>
                  }
                  {!isDisAvukat && 
                    <div className="form-group col-md-6">
                      <Field
                        name="sorumluEposta"
                        label={t("demandCreate.sorumluEPosta")}
                        colNumber="-6"
                        component={Select}
                        options={configData && configData.tumKullanicilar.filter(a => a.otherValue && a.otherValue != '').map(a => { return { value: a.otherValue, label: a.otherValue } })}
                        buttonLabel = {
                          <>
                            <Button
                              className="btn-xs ml-3 px-2 py-1 rounded-circle"
                              variant="primary"
                              onClick={() => setSorumluEpostaTextboxVisibility(!sorumluEpostaTextboxVisibility)}
                            >
                                <i className={ "fa fa-" + (sorumluEpostaTextboxVisibility ? "minus" : "plus") }/>
                            </Button>
                          </>
                        }
                        readOnly={isDisAvukat}
                        required
                      />
                      { sorumluEpostaTextboxVisibility &&
                        <Field
                          name="sorumluEposta"
                          label={t("demandCreate.other")}
                          colNumber="-6 hide-label"
                          component={EmailInput}
                          readOnly={isDisAvukat}
                          required
                        />
                      }
                    </div>
                  }
                  {!isDisAvukat && <Field
                    name="sorumluTel"
                    label={t("demandUpdate.sorumluTelefon")}
                    colNumber="6"
                    component={TextInput}
                    readOnly={isDisAvukat}
                    required
                  />}
                  {/* <Field
                    name="sorumluRolu"
                    label="Sorumlu Rolü"
                    colNumber="6"
                    component={TextInput}
                  /> */}
                  {!isDisAvukat && props.selectedRow &&
                    (typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        //DEMAND_TYPES.DAVA_YENI_TALEP,
                        //DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.FMH_YENI_DAVA,
                        DEMAND_TYPES.FMH_ALEYHE_DAVA,
                        DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                        DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                        DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      ],
                      props.pageType,
                      [1, 2]
                    )) && (
                      <Field
                        name="davaTuru"
                        label={t("demandUpdate.davaTuru")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.davaTurleri}
                      />
                    )
                  }

                  {!isDisAvukat && props.selectedRow &&
                    (typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.SAVCILIK,
                        DEMAND_TYPES.PLADIS_SAVCILIK,
                        DEMAND_TYPES.TIO_SAVCILIK,
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.TH_KAMULASTIRMA,
                        DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                        DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                        DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_YENIDAVA
                      ],
                      props.pageType,
                      [1, 2]
                    )) && (
                      <>
                        <Field
                          name="ilkDavaTuru"
                          label={t("demandUpdate.davaTuru1")}
                          colNumber="6"
                          component={Select}
                          options={getDavaTuru1Options()}
                          onChangeFunc={(val) => {
                              setSlctdDavaTuru(val);
                            }
                          }
                        />

                        {
                          typeCheck(slctdDavaTuru, davaTuru2Types) && <Field
                            name="ikinciDavaTuru"
                            label={t("demandUpdate.davaTuru2")}
                            colNumber="6"
                            component={Select}
                            options={getDavaTuru2()}
                          />
                        }
                      </>
                  )}
                  <Field
                    name="dosyaTuruList"
                    label={t("demandUpdate.dosyaTuru")}
                    colNumber="6"
                    component={MultiSelect}
                    options={configData && configData.dosyaTurleri}
                    isDisabled={isDisAvukat}
                    required
                  />
                  <Field
                    name="konu"
                    label={t("demandUpdate.konu")}
                    colNumber="12"
                    component={TextArea}
                    disabled={isDisAvukat}
                    required
                  />
                  {!isDisAvukat && <Field
                    name="aciklama"
                    label={t("demandUpdate.explanation")}
                    colNumber="12"
                    component={TextArea}
                    readOnly={isDisAvukat}
                    required
                  />}
                  {props.selectedRow &&
                    davaliAndDavaciFieldsChecker() &&
                    (
                      <div className="form-group col-md-6">
                        <Field
                          name="tarafCompanyList"
                          label={t(tarafText)}
                          colNumber="-6"
                          component={MultiSelect}
                          options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                          readOnly={isDisAvukat}
                          required
                        />
                        <Field
                          name="taraf1"
                          label={t(tarafText)}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          readOnly={isDisAvukat}
                        /*required*/
                        />
                      </div>
                    )}
                  {props.selectedRow &&
                    typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.ICRA_TAKIBI,
                        DEMAND_TYPES.PLADIS_ICRA,
                        DEMAND_TYPES.TIO_ICRA_TAKIBI,
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.TH_KAMULASTIRMA,
                        DEMAND_TYPES.PLADIS_YENIDAVA,
                        //DEMAND_TYPES.GH_IS_HUKUKU,
                        DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.SAVCILIK,
                        DEMAND_TYPES.PLADIS_SAVCILIK,
                        DEMAND_TYPES.TIO_SAVCILIK,
                        DEMAND_TYPES.FMH_YENI_DAVA,
                        DEMAND_TYPES.FMH_ALEYHE_DAVA,
                        DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                        DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                        DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI
                      ],
                      props.pageType,
                      [1, 2]
                    ) &&
                    (
                      <div className="form-group col-md-6">
                        <Field
                          name="davaliCompanyList"
                          label={t(
                            ((props.selectedRow.talepTur.id == DEMAND_TYPES.SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_SAVCILIK))
                              ? "demandCreate.supheli"
                              : ((props.selectedRow.talepTur.id == DEMAND_TYPES.ICRA_TAKIBI) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_ICRA_TAKIBI) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_ICRA))
                                ? "demandCreate.borclu"
                                : "demandUpdate.davali"
                          )}
                          colNumber="-6"
                          component={MultiSelect}
                          options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                          readOnly={isDisAvukat}
                          required
                        />
                        <Field
                          name="davali"
                          label={t(
                            ((props.selectedRow.talepTur.id == DEMAND_TYPES.SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_SAVCILIK))
                              ? "demandCreate.supheli"
                              : ((props.selectedRow.talepTur.id == DEMAND_TYPES.ICRA_TAKIBI) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_ICRA_TAKIBI) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_ICRA))
                                ? "demandCreate.borclu"
                                : "demandUpdate.davali"
                          )}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          readOnly={isDisAvukat}
                        /*required*/
                        />
                      </div>
                    )}
                  {/*<Field
                                        name="higmyetkililer"
                                        label="HİGM Yetkilileri"
                                        colNumber="6"
                                        component={MultiSelect}
                                        options={configData && configData.users}
                                        // required
                                    />*/}

                  {!isDisAvukat && props.selectedRow &&
                    (typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.HISSE_ALIM_SATIM,
                        DEMAND_TYPES.VEKALETNAME,
                        DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                        DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                        DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
                        DEMAND_TYPES.YONETIM_KURULU_KARARLARI,
                        DEMAND_TYPES.YURTDISI_ISTIRAKLERI_DIGER,
                        DEMAND_TYPES.ESAS_SOZLESME,
                        DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI,
                        DEMAND_TYPES.DUE_DILIGENCE,
                        DEMAND_TYPES.SIRKETLER_HUKUKUNA_ILISKIN_GORUS,
                        DEMAND_TYPES.SOZLESME,
                        DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                        DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                        DEMAND_TYPES.GH_IS_HUKUKU,
                        DEMAND_TYPES.TIO_SOZLESME,
                        DEMAND_TYPES.RESMI_KURUM_TALEP,
                        DEMAND_TYPES.RESMI_MERCI_DENETIMLERI,
                        DEMAND_TYPES.SIRKET_YONETMELIK,
                        // DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
                      ],
                      props.pageType,
                      [1]
                    ) ||
                      typeCheckWithPage(
                        props.selectedRow.talepTur.id,
                        [
                          DEMAND_TYPES.HISSE_ALIM_SATIM,
                          DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
                          DEMAND_TYPES.ESAS_SOZLESME,
                          DEMAND_TYPES.SOZLESME,
                          DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                          DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                          DEMAND_TYPES.GH_IS_HUKUKU,
                          DEMAND_TYPES.TIO_SOZLESME,
                          DEMAND_TYPES.HALKA_ACIK_SIRKET,
                        ],
                        props.pageType,
                        [2]
                      )) && (
                      <Field
                        name="dil"
                        label={t("demandUpdate.dil")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.diller}
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.TH_KAMULASTIRMA,
                        //DEMAND_TYPES.GH_IS_HUKUKU,
                        DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.FMH_YENI_DAVA,
                        DEMAND_TYPES.FMH_ALEYHE_DAVA,
                        DEMAND_TYPES.PLADIS_YENIDAVA
                      ],
                      props.pageType,
                      [2]
                    ) && (
                      <Field
                        name="surecTarih"
                        label={t("demandUpdate.tarih")}
                        colNumber="6"
                        component={ReactDatePicker}
                        readOnly={isDisAvukat}
                      />
                    )}
                  {props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                    ]) && (
                      <Field
                        name="daireNo"
                        label={t(
                          ((
                            props.selectedRow.talepTur.id === DEMAND_TYPES.SAVCILIK) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_SAVCILIK) ||
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.TIO_SAVCILIK) ||
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_SAVCILIK))
                            ? "demandUpdate.savcilikNo"
                              : "demandUpdate.daireNo"
                        )}
                        colNumber="6"
                        component={TextInput}
                      /*required*/
                      />
                    )}
                  {props.selectedRow &&
                  typeCheck(props.selectedRow.talepTur.id, [
                    DEMAND_TYPES.DAVA_YENI_TALEP,
                    DEMAND_TYPES.TH_KAMULASTIRMA,
                    DEMAND_TYPES.PLADIS_YENIDAVA,
                    //DEMAND_TYPES.GH_IS_HUKUKU,
                    DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                    DEMAND_TYPES.SAVCILIK,
                    DEMAND_TYPES.PLADIS_SAVCILIK,
                    DEMAND_TYPES.TIO_SAVCILIK,
                    DEMAND_TYPES.FMH_YENI_DAVA,
                    DEMAND_TYPES.FMH_ALEYHE_DAVA,
                    DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                    DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                    DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                    DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                    DEMAND_TYPES.ICRA_TAKIBI,
                    DEMAND_TYPES.PLADIS_ICRA,
                    DEMAND_TYPES.TIO_ICRA_TAKIBI,
                    DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                  ]) && (
                      <Field
                          name="icraNo"
                          label={t("demandUpdate.icraNo")}
                          colNumber="6"
                          component={TextInput}
                          /*required*/
                      />
                  )}
                  {props.selectedRow && typeCheck(props.selectedRow.talepTur.id, [
                    64,
                    17,
                    90,
                    92,
                    83,
                    31,
                    DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                    DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                    DEMAND_TYPES.PLADIS_ICRA
                  ]) && (
                      <Field
                        name="mudahil"
                        label={t("demandCreate.müdahil")}
                        colNumber="6"
                        component={TextInput}
                      /*required*/
                      />
                    )}

                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [22, 33, DEMAND_TYPES.TIO_IHTARNAME, DEMAND_TYPES.GENEL_H_IHTARNAME, DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI]) && (
                      <Field
                        name="ihtarEsden"
                        label={t("demandCreate.ihtarEden")}
                        colNumber="6"
                        component={TextInput}
                        required
                      />
                    )}

                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.VEKALETNAME,
                      DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                    ]) && (
                      <Field
                        name="vekilSirket"
                        label={t("demandCreate.vekilinCalistigiSirket")}
                        colNumber="6"
                        component={TextInput}
                        readOnly={isDisAvukat}
                      /*required*/
                      />
                    )}

                  {/* <Field
                        name="GHIBYetkilisiGorebilir"
                        checkboxText="GHİB Yetkilisi Görebilir"ß
                        colNumber="6"
                        component={Checkbox}
                    />
                    <Field
                        name="grupSirketiYetkilisiGorebilir"
                        checkboxText="Grup şirketi yetkilisi görebilir"
                        colNumber="6"
                        component={Checkbox}
                    /> */}
                  {props.type != 1 && (
                    <Field
                      name="avukatYorumu"
                      label={t("demandUpdate.avukatYorumu")}
                      colNumber="6"
                      component={TextArea}
                    />
                  )}
                  { props.selectedRow && props.selectedRow.avukat && (userObj.id === props.selectedRow.avukat.id || userObj.id === props.selectedRow?.createdUser?.id) && !isDisAvukat && <Field
                    name="yonlendiriciYorum"
                    label={t("demandUpdate.yonlendiriciYorumu")}
                    colNumber="6"
                    component={TextArea}
                    readOnly={props.type == 2}
                  />}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA
                    ]) && (
                      <Field
                        name="szlThmBedelTuru"
                        label={t(
                          ((props.selectedRow.talepTur.id ===
                            DEMAND_TYPES.SOZLESME) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.TIO_SOZLESME) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.GH_IS_HUKUKU))
                            ? "demandCreate.sozlesmeBedeli"
                            : "documentUpdate.tahminiBedel"
                        )}
                        colNumber="6"
                        component={Select}
                        options={
                          configData && configData.szlTahminiBedelTurleri
                        }
                        onChangeFunc={(val) => onBedelChanged(val)}
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      //DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      //DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                    ]) && (
                      <Field
                        name="paraBirimi"
                        label={t("demandCreate.paraBirimi")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.paraBirimleri}
                        isDisabled={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      /*DEMAND_TYPES.DAVA_YENI_TALEP,*/
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      /*DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,*/
                      /*DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,*/
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      /*DEMAND_TYPES.TIO_DAVA_YENI_TALEP,*/
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                    ]) && (
                      <Field
                        name="bedel"
                        label={t(
                          props.selectedRow.talepTur.id ==
                            DEMAND_TYPES.DAVA_YENI_TALEP ||
                            props.selectedRow.talepTur.id ==
                            DEMAND_TYPES.TH_KAMULASTIRMA ||
                            props.selectedRow.talepTur.id ==
                            DEMAND_TYPES.PLADIS_YENIDAVA ||
                            props.selectedRow.talepTur.id ==
                            DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI
                            ? "demandCreate.davaTutari"
                            : props.selectedRow.talepTur.id ==
                              DEMAND_TYPES.ICRA_TAKIBI
                              ? "demandCreate.takipTutari"
                              : "demandCreate.bedel"
                        )}
                        colNumber="6"
                        component={CurrencyInput}
                        placeholder="0,00"
                        required
                        readOnly={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                      />
                    )}
                    {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                    ]) && (
                      <Field
                        name="bedel"
                        label={typeCheck(props.selectedRow.talepTur.id, [
                          DEMAND_TYPES.TIO_MUTALAA,
                          DEMAND_TYPES.TIO_IHTARNAME,
                          DEMAND_TYPES.TIO_SOZLESME,
                          DEMAND_TYPES.TIO_SOZLESMELERLE_ILGILI_SORU,
                          DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                          DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                          DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                          DEMAND_TYPES.TIO_SAVCILIK,
                          DEMAND_TYPES.TIO_ICRA_TAKIBI,
                          DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
                          DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                          DEMAND_TYPES.TIO_RAPORLAMALAR,
                          DEMAND_TYPES.TIO_SIRKETEGITIM,
                          DEMAND_TYPES.IS_HUKUKU_FESIH,
                          DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
                          113
                        ]) ? t("demandCreate.muddeabihRisk") : t("demandCreate.muddeabih")}
                        colNumber="6"
                        component={CurrencyInput}
                        placeholder="0,00"
                        /*required*/
                        readOnly={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [9]) && (
                      <Field
                        name="basvurulanSirket"
                        label={t("demandCreate.basvuruYapilacakSirket")}
                        colNumber="6"
                        component={TextInput}
                        required
                      />
                    )}
                  {props.selectedRow &&
                    typeCheck(
                      props.selectedRow.talepTur.id,
                      [64, 17, 18, 26, 25, 16, 69, 80, 31, 83, 89, 90, 91, 92, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]
                    ) && (
                      <Field
                        name="durusmaTarihi"
                        label={t("demandCreate.durusmaTarihi")}
                        colNumber="6"
                        component={ReactDatePicker}
                      />
                    )}

                  {!isDisAvukat && (initialValues?.iadeTarihi || props.type == 3 || props.type == 2) && (
                    <Field
                      name="iadeNedeni"
                      label={t("demandUpdate.iadeNedeni")}
                      colNumber="6"
                      component={TextInput}
                      onChangeFunc={(value) =>
                        props.setReturnReason && props.setReturnReason(value)
                      }
                      readOnly={props.type == 1}
                    />
                  )}
                  {!isDisAvukat && initialValues?.iadeTarihi && (
                    <Field
                      name="iadeEdenUser"
                      label={t("demandUpdate.iadeEdenKullanici")}
                      colNumber="6"
                      component={TextInput}
                      readOnly
                    />
                  )}
                  {!isDisAvukat && initialValues?.iadeTarihi && (
                    <Field
                      name="iadeTarihi"
                      label={t("demandUpdate.iadeTarihi")}
                      colNumber="6"
                      component={TextInput}
                      readOnly
                    />
                  )}
                  {!isDisAvukat && props.type == 1 && (
                    <Field
                      name="redNedeni"
                      label={t("demandUpdate.redNedeni")}
                      colNumber="6"
                      component={TextInput}
                      onChangeFunc={(value) =>
                        props.setRejectReason && props.setRejectReason(value)
                      }
                    />
                  )}
                  {/* {
                    (props.selectedRow && props.selectedRow.talepDurum.id != 2) && !isDisAvukat && 
                    <Field
                      name="bilgideTutulanlar"
                      label={t("demandUpdate.bilgideTut")}
                      colNumber="6"
                      component={MultiSelect}
                      menuPlacement={'top'}
                      options={configData && configData.bilgideTutList}
                      isDisabled={isDisAvukat}
                    />
                  } */}
                  {/* {props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                    ]) &&
                    props.pageType != 1 && (
                      <Field
                        name="dosyaDurumId_2"
                        label={t("demandUpdate.dosyaDurum")}
                        colNumber="6"
                        component={Select}
                        options={davaDosyaDurum}
                      />
                    )} */}
                  {!isDisAvukat && (props.pageType == 2 || props.type == 3) && (
                    <div className="form-group col-md-6">
                      <Field
                        name="isGucuBirimId"
                        label={t("demandUpdate.isGucuBirim")}
                        colNumber="-6"
                        component={Select}
                        menuPlacement={'top'}
                        onChangeFunc={(val) => onIsGucuBirimChange(val)}
                        options={configData && configData.isGucu}
                        isDisabled={isDisAvukat || disableIsGucu}
                        required
                      />
                      {
                        isGucuTextboxVisibility && <Field
                          name="isGucuBirimIdDiger"
                          label={t("demandUpdate.isGucuBirimDiger")}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          resetValue={isGucuTextboxVisibility}
                        />
                      }
                    </div>
                  )}

                    {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [89, 90, 92, 16, 64, 17, 91, 31, 83, 18, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]) && (
                      <Field
                        name="updateOnemli"
                        label={t("demandUpdate.importantInfo")}
                        colNumber="6"
                        component={Checkbox}
                        value={props.selectedRow?.onemli ? true : false} 
                      />
                    )}
                  {
                    /* (props.selectedRow && (props.selectedRow.talepDurum.id == 2 || props.selectedRow.talepDurum.id == 1)) &&  */
                    !isDisAvukat && 
                      <>
                        <Field
                          name="avukatId"
                          label={t("demandUpdate.delegeEdilen")}
                          colNumber="6"
                          component={Select}
                          options={configData && configData.users}
                          isDisabled={isDisAvukat}
                          required
                        />
                        <Field
                          name="bilgideTutulanlar"
                          label={t("demandUpdate.bilgideTut")}
                          colNumber="6"
                          component={MultiSelect}
                          menuPlacement={'top'}
                          options={configData && configData.bilgideTutList}
                          isDisabled={isDisAvukat}
                        />
                    </>
                  }
                  {!isDisAvukat && props.selectedRow &&
                    props.type != 1 &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                    ]) && (
                      <Field
                        name="gorevlendirilmisDisAvukatlar"
                        label={t("demandUpdate.gorevlendirilenDisAvukat")}
                        colNumber="6"
                        component={MultiSelect}
                        options={configData && configData.disAvukatlar}
                        isDisabled={isDisAvukat}
                        maxLimit={2}
                      />
                  )}
                  {props.selectedRow &&
                    props.type != 1 &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                      DEMAND_TYPES.TIO_SOZLESME,
                      DEMAND_TYPES.VEKALETNAME,
                      DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                    ]) && (
                      <Field
                        name="dosyaDurumId"
                        label={t("demandUpdate.dosyaDurum")}
                        colNumber="6"
                        component={Select}
                        menuPlacement={'top'}
                        options={configData && configData.dosyaDurum}
                        onChangeFunc={(opt) => onDosyaDurumuChange(opt)}
                      />
                    )}
                  {/* {props.selectedRow &&
                    (typeCheckWithPage(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.SAVCILIK,
                        DEMAND_TYPES.BASIN_HUKUKU,
                        DEMAND_TYPES.HACIZ_IHBARNAMELERI,
                        DEMAND_TYPES.IS_HUKUKU_FESIH,
                        DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                        DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                        DEMAND_TYPES.DAVA_ICRA_EGITIM,
                        DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
                        // DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
                        // DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
                      ],
                      props.pageType,
                      [1]
                    ) ||
                      typeCheckWithPage(
                        props.selectedRow.talepTur.id,
                        [
                          // DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
                          // DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
                          DEMAND_TYPES.DAVA_YENI_TALEP,
                          DEMAND_TYPES.SAVCILIK,
                          DEMAND_TYPES.FMH_YENI_DAVA,
                          DEMAND_TYPES.ICRA_TAKIBI,

                          DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                          DEMAND_TYPES.HACIZ_IHBARNAMELERI,
                          DEMAND_TYPES.IS_HUKUKU_FESIH,
                          DEMAND_TYPES.BASIN_HUKUKU,
                          DEMAND_TYPES.DAVA_ICRA_EGITIM,

                          DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
                        ],
                        props.pageType,
                        [2]
                      )) && (
                      <Field
                        name="disAvukatGorebilir"
                        checkboxText={t("demandUpdate.disAvukatGorebilir")}
                        colNumber="6"
                        component={Checkbox}
                      />
                    )} */}

                  {/* {props.type == 1 && (
                    <Field
                      name="redEdenUserId"
                      label={t("demandUpdate.redEdenKullanici")}
                      colNumber="6"
                      component={TextInput}
                      readOnly
                    />
                  )}
                  {props.type == 1 && (
                    <Field
                      name="redTarihi"
                      label={t("demandUpdate.redTarihi")}
                      colNumber="6"
                      component={TextInput}
                      readOnly
                    />
                  )} */}
                </FormikForm>
              </Tab.Pane>
              <Tab.Pane eventKey={"sondurum"} key={2}>
                <LastStatus
                  refreshList={() => props.setRefreshList(!props.refreshList)}
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>

              <Tab.Pane eventKey={"dokumanlar"} key={3}>
                <Documents
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>

              <Tab.Pane eventKey={"harcanansureler"} key={4}>
                <TimesSpent
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={"dosyagecmisi"} key={5}>
                <DocumentHistory selectedRow={props.selectedRow} />
              </Tab.Pane>
              { props.selectedRow && IsMasrafCheck && (typeCheck(props.selectedRow.talepTur.id, MASRAF_TAB_CASES )) && (
                <Tab.Pane eventKey={"masraflar"} key={6}>
                  <Expenses selectedRow={props.selectedRow} isUpdating={props.isUpdating} />
                  <Documents
                    selectedRow={props.selectedRow}
                    disableButtons={disableButtons}
                    masrafMi={ true }
                  />
                </Tab.Pane>
              )}
            </Tab.Content>
          </Tab.Container>
        </CrudMain>
      </div>
    </div>
  );
}

export default DemandUpdate;
